import React, { useState, useEffect } from 'react';

let isInChange = false;
let interval;

export function Range({ max, initial, muted, className, onChange, ...props }) {

    const [value, setValue] = useState(initial);
    const [isMuted, setMuted] = useState(muted);

    const changeValue = (val) => {
        if(!isMuted){
        isInChange = true;        
        if(interval)
            clearTimeout(interval)
        setValue(val);
        if (typeof onChange === 'function') {
            onChange(val);
        }
        interval = setTimeout(() => {
            isInChange = false;
        }, 300);
    }
    }

    const onInputChange = (e) => {
        changeValue(Math.round(e.target.value * 10) / 10)
    };

    /*useEffect(() => { 
        if(!isInChange && !isMuted)
            setValue(value);
      }, [props]);
      */
      useEffect(() => { 
        setMuted(muted);
      }, [muted]);

      useEffect(() => {
        
        if(props.value && value != props.value)
            setValue(props.value)
    
      }, [props]);


    max = max || 100;
    const getBackgroundSize = () => {
        return {
            backgroundSize: `${(value * 100) / max}% 100%`,
        };
    };

    const plus = () => {
        if(value <= (max - 0.1) && !isMuted) {           
            let newValue = Math.round(value * 10) / 10 + 0.1;
            changeValue(newValue)          
        }
    }

    const moins = () => {
        if(value >= 0.1 && !isMuted) {
            let newValue = Math.round(value * 10) / 10 - 0.1;
            changeValue(newValue)       
        }
    }

    //console.log('======================> value', value);
    return (        
        <div className={'range' + (className ? ' ' + className : '') + (isMuted ? ' muted' : '')}>
            <div className="range-plus" disabled={isMuted} onClick={plus}>+</div>
            <input type="range" 
                    className={'range__input'} 
                    value={value} 
                    onChange={onInputChange} 
                    style={getBackgroundSize()} 
                    max={max}
                    disabled={isMuted}
                    readOnly={isMuted}
                    {...props} />
            <div className="range-moins" disabled={isMuted} onClick={moins}>-</div>
        </div>
    )
}

export function IconRange({ className, vertical, icon, onChange, ...props }) {

    console.log('======================> value IconRange', props.value);
    return (
        <div className={'icon-range ' + ( className ? className : '' ) + (vertical ? ' icon-range--vertical' : '')}>
            <div className="icon-range__icon">
                <i className={'icon-'+icon}></i>
            </div>
            <Range onChange={ onChange } className={'icon-range__input'} {...props} />
        </div>
    );
}